import { useState, useEffect } from "react";
import { StepType, STEPS } from "./sleep-dialog-types";

export function useSleepDialogState(activityToEdit?: any) {
  const [saving, setSaving] = useState(false);
  const [currentStep, setCurrentStep] = useState<StepType>('start');
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [locations, setLocations] = useState<{id: string, description: string}[]>([]);
  const [environments, setEnvironments] = useState<{id: string, description: string}[]>([]);
  const [onsetMethods, setOnsetMethods] = useState<{id: string, description: string}[]>([]);
  const [sounds, setSounds] = useState<{id: string, name: string}[]>([]);
  const [soundLevels, setSoundLevels] = useState<{id: string, level: string}[]>([]);
  const [restfulnessRatings, setRestfulnessRatings] = useState<{id: string, description: string}[]>([]);
  const [isEditing, setIsEditing] = useState(false);
  
  // Set whether we're editing on mount - using useEffect instead of useState
  useEffect(() => {
    if (activityToEdit) {
      console.log(' SLEEP DIALOG - EDITING MODE', {
        id: activityToEdit.id,
        type: activityToEdit.type,
        startTime: activityToEdit.startTime,
        notes: activityToEdit.notes,
        location: activityToEdit.location,
        environment: activityToEdit.environment,
        onset_method: activityToEdit.onset_method,
        sound: activityToEdit.sound,
        sound_level: activityToEdit.sound_level,
        quality: activityToEdit.quality,
      });
      setIsEditing(true);
    } else {
      setIsEditing(false);
    }
  }, [activityToEdit]);

  const nextStep = (formValues?: any) => {
    if (window.navigator && window.navigator.vibrate) {
      window.navigator.vibrate(50);
    }
    
    const currentIndex = STEPS.findIndex(step => step === currentStep);
    let nextIndex = currentIndex + 1;
    
    // Skip logic based on has_woken_up status
    if (formValues) {
      const hasWokenUp = formValues.has_woken_up;
      
      // Skip end time and restfulness if not woken up
      while (nextIndex < STEPS.length) {
        const nextStepType = STEPS[nextIndex];
        
        if (hasWokenUp !== 'yes' && (nextStepType === 'end' || nextStepType === 'restfulness')) {
          // Skip this step
          nextIndex++;
        } else {
          // This step should be shown
          break;
        }
      }
    }
    
    if (nextIndex < STEPS.length) {
      setCurrentStep(STEPS[nextIndex]);
    }
  };

  const prevStep = () => {
    if (window.navigator && window.navigator.vibrate) {
      window.navigator.vibrate(50);
    }

    const prevIndex = STEPS.findIndex(step => step === currentStep) - 1;
    if (prevIndex >= 0) {
      setCurrentStep(STEPS[prevIndex]);
    }
  };

  return {
    saving,
    setSaving,
    currentStep,
    setCurrentStep,
    showConfirmation, 
    setShowConfirmation,
    isEditing,
    setIsEditing,
    locations,
    setLocations,
    environments,
    setEnvironments,
    onsetMethods,
    setOnsetMethods,
    sounds,
    setSounds,
    soundLevels,
    setSoundLevels,
    restfulnessRatings,
    setRestfulnessRatings,
    nextStep,
    prevStep
  };
}
